import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TrashMediaPage from '../components/Trash/TrashMediaPage';
import {
  openTrashMedia,
  initTrashMediaInfo,
  updateTrashMediaInfo,
} from '../actions/trash';

const getMediaDetailHeight = () => {
  const headerNotice = document.getElementById('headerNotice');
  const title = document.getElementById('title');
  const height =
    (headerNotice && headerNotice.clientHeight) +
    (title && title.clientHeight) +
    15;
  return height || 0;
};

class TrashMediaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mediaDetailHeight: 0,
    };
    const params = {
      dispatch: (props && props.dispatch) || null,
    };
    openTrashMedia(params.dispatch);
  }

  componentDidMount() {
    const mediaDetailHeight = getMediaDetailHeight();
    this.setState({ mediaDetailHeight });
  }

  shouldComponentUpdate(props, state) {
    const resizedMediaDetailHeight = getMediaDetailHeight();
    const curMediaDetailHeight = state.mediaDetailHeight;
    if (resizedMediaDetailHeight !== curMediaDetailHeight) {
      this.setState({ mediaDetailHeight: resizedMediaDetailHeight });
    }
    const params = {
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      searchOptions: props && props.searchOptions,
      mediaId: props && props.match && props.match.params.mediaId,
      canUpdate: !props.showUserPrompt || props.isLogin,
    };
    const { dispatch, apiToken, mediaId, searchOptions } = params;
    if (params.canUpdate) {
      updateTrashMediaInfo(dispatch, apiToken, mediaId, searchOptions);
    }
    return true;
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    initTrashMediaInfo(dispatch);
  }

  render() {
    const { isLogin, apiToken } = this.props;
    const { mediaDetailHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <TrashMediaPage
          apiToken={apiToken}
          mediaDetailHeight={mediaDetailHeight}
        />
      )
    );
  }
}

TrashMediaContainer.propTypes = {
  apiToken: PropTypes.string.isRequired,
  isLogin: PropTypes.bool.isRequired,
  searchOptions: PropTypes.object.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  apiToken: state.main.apiToken,
  isLogin: state.main.isLogin,
  searchOptions: state.trash.trashMediaInfo.searchOptions,
  showUserPrompt: state.userPrompt.showUserPrompt,
});

export default withRouter(connect(mapStateToProps)(TrashMediaContainer));
